import {
    LegacyEpisodePlayerBaseInfoContent,
    SkippableFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { filterFragments } from '../../movie-player/utils/filter-skippable-fragments';
import { EMPTY_FRAGMENTS } from '../../feature-player/constants/skin';

import { getEpisodeOtt } from './get-episode-ott';

export function getEpisodeSkippableFragments(
    episode: LegacyEpisodePlayerBaseInfoContent | undefined | null
): SkippableFragment[] {
    const ott = episode && getEpisodeOtt(episode);
    const fragments = ott?.onlineStreams?.streams?.[0]?.streamMeta?.skippableFragments;

    return fragments ? filterFragments(fragments) : EMPTY_FRAGMENTS;
}
